var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsApiGateway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_82)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_82)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_82)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.5 146H132.5V143.5H127.5V146ZM115 94.155L97.5 101.755V151.892L115 157.99V94.155ZM117.5 108.5V143.5H122.5V146H117.5V159.75C117.5 159.949 117.452 160.146 117.361 160.323C117.269 160.5 117.137 160.652 116.974 160.768C116.812 160.883 116.624 160.958 116.427 160.987C116.229 161.015 116.028 160.995 115.84 160.93L95.84 153.962C95.5948 153.877 95.3822 153.718 95.2317 153.507C95.0811 153.295 95.0002 153.042 95 152.782V100.935C95 100.437 95.295 99.9875 95.7525 99.79L115.752 91.105C115.943 91.0225 116.15 90.9886 116.357 91.0063C116.563 91.0239 116.762 91.0926 116.935 91.2062C117.108 91.3197 117.251 91.4745 117.349 91.6567C117.448 91.8389 117.5 92.0428 117.5 92.25V106H122.5V108.5H117.5ZM162.5 101.755L145 94.155V157.99L162.5 151.892V101.755ZM165 100.935V152.782C165 153.042 164.919 153.295 164.768 153.507C164.618 153.718 164.405 153.877 164.16 153.962L144.16 160.93C143.972 160.994 143.771 161.013 143.573 160.986C143.376 160.958 143.188 160.884 143.025 160.77C142.862 160.654 142.73 160.501 142.639 160.324C142.547 160.146 142.5 159.95 142.5 159.75V146H137.5V143.5H142.5V108.5H137.5V106H142.5V92.25C142.5 92.0428 142.552 91.8389 142.651 91.6567C142.749 91.4745 142.892 91.3197 143.065 91.2062C143.238 91.0926 143.437 91.0239 143.643 91.0063C143.85 90.9886 144.057 91.0225 144.247 91.105L164.248 99.79C164.471 99.8866 164.661 100.046 164.795 100.25C164.929 100.453 165 100.692 165 100.935ZM127.5 108.5H132.5V106H127.5V108.5ZM139.938 115.145L137.562 114.355L130.062 136.855L132.438 137.645L139.938 115.145ZM127.865 133.135L120.365 125.635C120.131 125.4 120 125.082 120 124.75C120 124.418 120.131 124.1 120.365 123.865L127.865 116.365L129.635 118.135L123.018 124.75L129.635 131.365L127.865 133.135Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_82",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_82"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_82",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_82",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A166FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsApiGateway);
export default __webpack_public_path__ + "static/media/aws-api-gateway.d88a66e5ca7ff4213051052841e3659c.svg";
export { ForwardRef as ReactComponent };